// src/pages/DigidatesPage.js

import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ReactComponent as DigidateIcon } from '../assets/icon-digidate.svg';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

const DigidateCard = ({ digidate }) => {
  const imageUrl = digidate.image?.formats?.thumbnail?.url || digidate.image?.url;

  // Dag en maand opbouwen + punt verwijderen (okt. -> okt), altijd naast elkaar tonen
  const dateObj = new Date(digidate.event_date);
  const day = dateObj.toLocaleDateString('nl-NL', { day: 'numeric' });
  const rawMonth = dateObj.toLocaleDateString('nl-NL', { month: 'short' });
  const month = (rawMonth || '').replace('.', '');

  return (
    <Link to={`/webinars/${digidate.slug}`} className="digidate-card">
      <div className="digidate-card-image">
        {imageUrl ? <img src={imageUrl} alt={digidate.title} /> : <DigidateIcon />}
      </div>
      <div className="digidate-card-content">
        <div>
          <h4>{digidate.title}</h4>
          <p>{digidate.summary}</p>
        </div>
        {digidate.has_taken_place && (
          <div className="digidate-card-tag">Opname</div>
        )}
      </div>
      <div className="digidate-card-date">
        <span>
          {day} {month}
        </span>
      </div>
    </Link>
  );
};

function DigidatesPage() {
  const [digidates, setDigidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    const fetchDigidates = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await axios.get(
          `${STRAPI_URL}/api/digidates?sort=event_date:desc&populate=image`,
          { headers: { Authorization: `Bearer ${jwt}` } }
        );
        setDigidates(response.data.data);
      } catch (err) {
        setError("De webinars laden lukte niet. Probeer het opnieuw.");
        console.error("Fout bij ophalen Webinars:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDigidates();
  }, []);

  const { upcomingDigidates, pastDigidates } = useMemo(() => {
    const upcoming = digidates
      .filter(d => !d.has_taken_place)
      .sort((a, b) => new Date(a.event_date) - new Date(b.event_date));
    const past = digidates.filter(d => d.has_taken_place);
    return { upcomingDigidates: upcoming, pastDigidates: past };
  }, [digidates]);

  if (loading) return <p>Webinars worden geladen...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="digidates-page-container">
      <div className="overview-header-split">
        <h1>Webinars</h1>
        <p>
          In onze webinars vertellen leraren en experts hoe zij doorloopjes in hun klas gebruiken. Ze laten zien wat werkt. Tijdens een webinar kun je live vragen stellen. Hier meld je je aan voor de volgende webinars. Eerdere webinars kun je terugkijken wanneer het jou uitkomt.
        </p>
      </div>
      <div className="digidates-columns">
        <section className="digidate-column">
          <h2>Aankomend</h2>
          <div className="digidate-list">
            {upcomingDigidates.length > 0 ? (
              upcomingDigidates.map(d => <DigidateCard key={d.id} digidate={d} />)
            ) : (
              <p className="empty-state">Er zijn op dit moment geen aankomende webinars gepland.</p>
            )}
          </div>
        </section>
        <section className="digidate-column">
          <h2>Opnames</h2>
          <div className="digidate-list">
            {pastDigidates.length > 0 ? (
              pastDigidates.map(d => <DigidateCard key={d.id} digidate={d} />)
            ) : (
              <p className="empty-state">Er zijn nog geen opnames beschikbaar.</p>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}

export default DigidatesPage;
